// modules/tooltip.js
import tippy from 'tippy.js';

export function init() {
    // Select all elements with data-tooltip
    document.querySelectorAll('[data-tooltip]').forEach(el => {
        tippy(el, {
            allowHTML: true,
            content: el.dataset.tooltip,
            trigger: 'click',
            interactive: true,
            placement: 'top',
            duration: [300, 300],
        });
    });
}
